import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { RootStore } from './RootStore';

const StoreContext = createContext<RootStore | null>(null);

export function StoreProvider({
  children,
  store,
}: {
  children: ReactNode;
  /** Tests may inject a fresh RootStore. */
  store?: RootStore;
}) {
  const value = useMemo(() => store ?? new RootStore(), [store]);
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export function useStores(): RootStore {
  const root = useContext(StoreContext);
  if (!root) throw new Error('StoreProvider is missing above this component');
  return root;
}
